import NotFound from './pages/NotFound'
import Confirmation from './pages/Confirmation'
import YourAddress from './pages/YourAddress'
import Home from './pages/Home'
import ContactUsSuccess from './pages/ContactUsSuccess'
import Maintenance from './pages/Maintenance'
import { publicPath } from '../vue.config'

export default [
  { path: ``, redirect: `${publicPath}` },
  { path: `${publicPath}`, component: Home },
  { path: `${publicPath}/enquiry/:type(return|replacement|rma-status)`, component: Home },
  { path: `${publicPath}/address`, component: YourAddress },
  { path: `${publicPath}/confirmation`, component: Confirmation },
  { path: `${publicPath}/contact-us-success`, component: ContactUsSuccess },
  { path: `${publicPath}/maintenance`, component: Maintenance },
  { path: '*', component: NotFound }
]

